import { Autocomplete, Divider, Grid, ListItemIcon, ListItemText, TextField, Typography } from '@mui/material';
import React, { useContext, useState } from 'react'
import clsx from "clsx";

import styles from './../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import globalStyle from "../../../../../../assets/styles/global.module.scss"
import autoCompleteStyles from './../../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss'

import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import ArchiveIcon from '@mui/icons-material/Archive';

import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../../context/flowBuilderContext';
import { customVariableDataInterface } from '../../../../../../models/axiosModel';
import { isCurrentViewVersionPublished } from '../../../utilityFunctions';
import { WorkflowContext, WorkflowContextPayload } from '../../../../../../context/workflowContext';
import { useFlowBuilderStore } from '../../../../../../store/flowBuilderStore';
import { primaryColor } from '../../../../../../utils/colors';
import { filterAutocompleteOptionsWithException } from '../../../../../../utils/constants';
import { isWhatsAppChannel } from '../../../../../../pages/ruleBasedInbox/channelConstants';
import { AiExtractValueField } from './aiExtractValueField';

interface fieldListInterface {
    setFlagAdvancedOptions: React.Dispatch<React.SetStateAction<boolean>>,
    flagSaveData?: boolean,
    actionData: any,
    stepAction: any,
}

const FieldsListOption = (props: fieldListInterface) => {
    
    const { setFlagAdvancedOptions, flagSaveData, actionData, stepAction } = props;

    const customVariableList = useFlowBuilderStore((state) => state.customVariableList)
    const setFlagDeleteData = useFlowBuilderStore((state) => state.setFlagDeleteData)
    const setFlagUpdateFieldData = useFlowBuilderStore((state) => state.setFlagUpdateFieldData)
    const setFlagDataCollectionPopup = useFlowBuilderStore((state) => state.setFlagDataCollectionPopup)
    const existingCustomVariablePayload = useFlowBuilderStore((state) => state.existingCustomVariablePayload)
    const setExistingCustomVariablePayload = useFlowBuilderStore((state) => state.setExistingCustomVariablePayload)

    const { onChangeCurrentActiveNodeConfig, nodes, onBlurOfFallBackOfBtnVar, currentActiveNodeConfig } = useContext(FlowBuilderContext) as FlowBuilderContextPayload
    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload
    
    const handleEditFieldData = (event: any, option: customVariableDataInterface) => {
        event.stopPropagation();
        setFlagDataCollectionPopup(true);
        setFlagUpdateFieldData(true);
        setExistingCustomVariablePayload({
            ...existingCustomVariablePayload,
            chatbot_custom_variable_config_id: option.chatbot_custom_variable_configuration_id,
            chatbot_custom_variable_name: option.chatbot_custom_variable_name,
            chatbot_custom_variable_fallback_value: option.chatbot_custom_variable_fallback_value
        })
    }

    const handleDeleteFieldData = (event: any, option: customVariableDataInterface) => {
        event.stopPropagation();
        setExistingCustomVariablePayload({
            ...existingCustomVariablePayload,
            chatbot_custom_variable_config_id: option.chatbot_custom_variable_configuration_id,
            chatbot_custom_variable_name: option.chatbot_custom_variable_name,
            chatbot_custom_variable_fallback_value: option.chatbot_custom_variable_fallback_value
        })
        if (setFlagDeleteData) {
            setFlagDeleteData(true)
        }
    }

    const renderOptions = (props: React.HTMLAttributes<HTMLLIElement>, option: any): React.ReactNode => {
        if (option.chatbot_custom_variable_configuration_id == "-1" && option.chatbot_custom_variable_name == "New Field") {
            return (
                <ul className={autoCompleteStyles.newTagNameUlElement}>
                    <Divider className={autoCompleteStyles.newTagDivider} />
                    <li {...props} style={{ minHeight: "auto", cursor: "pointer", padding: "10px 16px", display: "flex", alignItems: "center", gap: "5px", boxSizing: "border-box", outline: "none", color: primaryColor }} onClick={() => { setFlagDataCollectionPopup(true); }}>
                        <AddIcon />
                        <Typography sx={{ fontSize: "15px", fontWeight: "500" }}>New Field</Typography>
                    </li>
                </ul>
            )
        }
        return (
            <li {...props} key={option.chatbot_custom_variable_configuration_id}>
                <Grid container>
                    <ListItemText primary={option.chatbot_custom_variable_name} className={styles.listItemsStyle} />
                </Grid>
                <Grid container justifyContent={"end"} sx={{ maxWidth: "60px" }}>
                    <Grid item onClick={(e) => e.stopPropagation()}>
                        <ListItemIcon onClick={(event) => handleEditFieldData(event, option)} sx={{ padding: "0", minWidth: "10px !important" }}>
                            <EditIcon className={globalStyle.menuIcon14px} />
                        </ListItemIcon>
                    </Grid>
                    <Grid item onClick={(e) => e.stopPropagation()} paddingLeft={"12px"}>
                        <ListItemIcon onClick={(event) => handleDeleteFieldData(event, option)} sx={{ padding: "0", minWidth: "10px !important" }}>
                            <ArchiveIcon className={globalStyle.menuIcon14px} />
                        </ListItemIcon>
                    </Grid>
                </Grid>
            </li>
        )
    }

    const onChangeOfAiExtraction = (value: boolean) => {
        const updateTypeObj = {
            type: "update_flag_ai_extraction",
            value: value
        }
        onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, updateTypeObj,
            {
                updateType: "editExistingStepAction"
            }
        ); 

        if((!flagSaveData && actionData.chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id)) {
            onBlurOfFallBackOfBtnVar(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, updateTypeObj,
                {
                    updateType: "editExistingStepAction"
                }
            )
        }
    }

    const handleFieldChange = (_: React.SyntheticEvent, value: customVariableDataInterface | null) => {
        const hadConfiguredField = !!actionData?.chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id;

        onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, value,
            {
                updateType: "editExistingStepAction"
            }
        );

        if (flagSaveData) {
            return;
        }

        if (value) {
            onBlurOfFallBackOfBtnVar(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, value,
                {
                    updateType: "editExistingStepAction"
                }
            );
        } else if (hadConfiguredField) {
            onBlurOfFallBackOfBtnVar(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id,
                { type: 'clear_selected_field' },
                {
                    updateType: "editExistingStepAction"
                }
            );
        }
    }

    const channelName = currentActiveStaticWorkflow?.chatbot_channel?.channel_name;
    const isWhatsapp = isWhatsAppChannel(channelName);

    return (
        <Grid item mt={2}> 
            <>
                <Grid container gap={1.5} alignItems={"center"}>
                    {Array.isArray(actionData) ?
                            <>
                                {/* <div style={{ display: "flex", flexWrap: "nowrap", gap: "4px" }}><span>{actionData.map((payloadKeyVar: any) => {
                                    return <><div style={{ fontSize: "15px", fontWeight: "500" }}>{payloadKeyVar.action_data.payload_key} : {payloadKeyVar.action_data?.chatbot_custom_variable_configuration?.chatbot_custom_variable_name || ""},</div></>
                                })}</span></div> */} 
                                <Grid item sx={{fontSize: "15px", fontWeight: "600", cursor: "pointer", color: "#3D5B99"}} onClick={() => {
                                    setFlagAdvancedOptions(true)
                                    onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, { type: 'store_backup_value' },
                                        {
                                            updateType: "editExistingStepAction"
                                        }
                                    );
                                }}>
                                    View configured payload of the output and flow output variables and webhook payload keys
                                </Grid>
                            </>
                            :
                            <>
                                <Grid item className={styles.contentBlockSubHeadingStyle} xs={12}>
                                    <Grid container className={clsx(globalStyle.displayFlex)} flexWrap={"nowrap"} gap={1}>
                                        <Grid item className={styles.fieldHeadingStyle}>
                                            Field:
                                        </Grid>
                                        <Grid item xs={12} sx={{ '&:hover': { backgroundColor: "rgba(0,0,0,0.02)" }, padding: "2px 4px" }}>
                                            <Autocomplete
                                                className={`${autoCompleteStyles.contactFilterDropdownsInPopup}`}
                                                options={customVariableList?.custom_variable_data ? [...customVariableList?.custom_variable_data.filter((data) => data.flag_archived == false), {
                                                    chatbot_custom_variable_configuration_id: "-1",
                                                    chatbot_custom_variable_name: "New Field",
                                                    chatbot_custom_variable_fallback_value: "",
                                                    flag_archived: false
                                                }] : []}
                                                filterOptions={(options, state) => filterAutocompleteOptionsWithException(options, state, "chatbot_custom_variable_name", "chatbot_custom_variable_configuration_id")}
                                                getOptionLabel={(option) => option.chatbot_custom_variable_name || ''}
                                                value={customVariableList?.custom_variable_data.find((variable) => variable.chatbot_custom_variable_configuration_id == actionData.chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id) || null}
                                                sx={{ '&:hover': { backgroundColor: "white !important" }, backgroundColor: "white !important" }}
                                                onChange={handleFieldChange}
                                                disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                                ListboxProps={{ style: { maxHeight: '150px', overflow: 'auto', paddingBottom: "50px" } }}
                                                renderOption={(props: React.HTMLAttributes<HTMLLIElement>, option: customVariableDataInterface) => { return renderOptions(props, option); }}
                                                renderInput={params => {
                                                    const { InputProps, ...restParams } = params;
                                                    const { startAdornment, ...restInputProps } = InputProps;
                                                    return (
                                                        <TextField
                                                            {...restParams}
                                                            placeholder='Select Field'
                                                            InputProps={{
                                                                ...restInputProps,
                                                                startAdornment: (
                                                                    <div style={{
                                                                        maxHeight: "90px",
                                                                        overflowY: 'auto',
                                                                    }}
                                                                    >
                                                                        {startAdornment}
                                                                    </div>
                                                                ),
                                                            }}
                                                        />
                                                    );
                                                }} 
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {isWhatsapp &&
                                    <AiExtractValueField
                                        checked={actionData?.flag_ai_extraction ?? false}
                                        onChange={onChangeOfAiExtraction}
                                        disabled={!actionData.chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id}
                                    />
                                }
                            </>
                    }
    
                </Grid>
                
                {isWhatsapp && !isCurrentViewVersionPublished(currentActiveStaticWorkflow) && !flagSaveData && !Array.isArray(actionData) &&
                    <Grid container flexWrap={"nowrap"} alignItems={"center"} justifyContent={"end"} mt={"4px"}>
                        <Grid item className={styles.fieldHeadingStyle} mt={"4px"} sx={{ cursor: "pointer", color: Array.isArray(actionData) ? "blue !important" : "" }} onClick={() => {
                            setFlagAdvancedOptions(true)
                            onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, { type: 'store_backup_value' },
                                {
                                    updateType: "editExistingStepAction"
                                }
                            );
                        }}>
                            Advanced Options
                        </Grid>
                    </Grid>
                } 
            </>
        </Grid>
    )
}

export default FieldsListOption
